export const graphSalesLeadsConstants = {
  GET_REQUEST: 'GRAPH_SALES_LEADS_GET_REQUEST',
  GET_SUCCESS: 'GRAPH_SALES_LEADS_GET_SUCCESS',
  GET_FAILURE: 'GRAPH_SALES_LEADS_GET_FAILURE',
};
